import { Component, input, OnInit } from '@angular/core';
import { faChevronRight, faFileLines, faFire } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { ReportService } from 'src/app/services/report.service';

@Component({
    selector: 'team-assignments',
    templateUrl: './team-assignments.component.html',
    styleUrls: ['./team-assignments.component.scss'],
    standalone: false
})


export class TeamAssignmentsComponent implements OnInit {
  //icons
  faFileLines = faFileLines;
  faChevronRight = faChevronRight;
  faFire = faFire;

  //table variables
  reports = new MatTableDataSource<any>();
  report_count = 0;
  displayedColumns = [
    'name',
    'reportId',
    'forest_name',
    'skills',
    'date',
    'action'
  ];

  //dropdown lists
  regions: any;
  statuses: any;
  complexities: any;
  team_leads: any;
  yearsArray: any;

  //access
  user = input.required<any>();
  currentDate = new Date();

  constructor(
    private readonly reportsService: ReportService,
  ) {
  }

  ngOnInit(): void {
    this.loadReportData();
  }

  loadReportData() {
    let reportRelations = '&relations=users.skills,assessment ';

    this.reportsService.getReportListByUser(reportRelations, this.user().user_id).subscribe(
      {
        next: (data) => {
          let reports = data.reports;
          reports.sort((reportA: any, reportB: any) => reportB.report_id - reportA.report_id);
          reports = reports.filter((report: any) =>
            [0, 1].includes(report.report_status_id) &&
            this.currentDate >= (report.assessment.tentative_start_week ?? new Date('12/31/1999')) &&
            this.currentDate <= (report.assessment.close_out_date ?? new Date('12/31/9999'))
          )

          this.report_count = reports.length;
          reports = reports.slice(0, 5);
          this.setTooltip(reports);
          this.reports.data = reports;
        }
      });
  }

  setTooltip(reports: any) {
    /* Set report tooltip*/
    reports.forEach((report: any) => {
      let tooltip = '';
      for (let i = 1; report.users[0].skills.length - 1 >= i; i++) {
        tooltip += report.users[0].skills[i].skill.text + '\n'
      }
      report.tooltip = tooltip;
    });
  }
}